export default {
  getListOutLet: state => state.listOutlet,
  getAllOutLets: state => state.allOutlets
}
